"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const candidate_enum_1 = require("./candidate.enum");
exports.CandidateSchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    districtId: shared_1.UUIDSchema.nullable(),
    userId: shared_1.UUIDSchema,
    email: zod_1.default.string(),
    firstName: zod_1.default.string(),
    lastName: zod_1.default.string(),
    address: zod_1.default.string().nullable(),
    phoneNumber: zod_1.default.string().nullable(),
    postalCode: zod_1.default.string().nullable(),
    selfIntroduction: zod_1.default.string().nullable(),
    hasManagementExperience: zod_1.default.boolean(),
    hideCompanyName: zod_1.default.boolean(),
    openToCompanyOffer: zod_1.default.boolean(),
    openToDirectMessage: zod_1.default.boolean(),
    subscribedToNewsletter: zod_1.default.boolean(),
    dateOfBirth: shared_1.ISODateSchema.nullable(),
    employmentStatus: candidate_enum_1.EmploymentStatusEnum,
    gender: candidate_enum_1.GenderEnum.nullable(),
    jobChangeCount: candidate_enum_1.JobChangeCountEnum,
    userNo: zod_1.default.int(),
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
